function capitalize(text){
    return text.split(' ').map(pn=>pn.charAt(0).toUpperCase()+pn.slice(1)).join(' ').split('-').map(pn=>pn.charAt(0).toUpperCase()+pn.slice(1)).join('-')
}

export default function badge(delegue, qr) {
    var dd = {
        pageSize: 'A4',
        // pageMargins: [ 20, 30, 20, 30 ],
        content: [
            {text: delegue.nom.toUpperCase(), fontSize: 24, alignment: 'center', bold: true},
            {text: capitalize(delegue.prenoms), fontSize: 22, alignment: 'center', bold: true},
            {image: qr, width: 150, height: 150, alignment: 'center'},
        ]    
    }
    return dd
}

export function badges(delegues) {
    const badgeWidth = 241; // ~85mm
    const badgeHeight = 153; // ~55mm
    const cols = 2; // 2 badges par ligne
    const rows = 5; // 5 badges par colonne
    const badgesPerPage = cols * rows; // 10 badges par page
    const totalPages = Math.ceil(delegues.length / badgesPerPage); // Nombre total de pages
    const pages = [];

    for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
        const tableBody = [];

        for (let i = 0; i < rows; i++) {
            const row = [];

            for (let j = 0; j < cols; j++) {
                const index = pageIndex * badgesPerPage + i * cols + j; // Index global du délégué

                if (index < delegues.length) {
                    const delegue = delegues[index];

                    row.push({
                        stack: [
                            { text: `${delegue.nom.toUpperCase()} ${capitalize(delegue.prenoms)}`, fontSize: 14, bold: true, alignment: "center", margin: [0, 10] },
                            { image: delegue.qr, width: 100, height: 100, alignment: "center" },
                        ],
                        border: [true, true, j === cols - 1, i === rows - 1], // Traits pour la découpe
                        width: badgeWidth,
                        height: badgeHeight,
                        margin: [5, 5, 5, 5], // Espacement interne
                    });
                } else {
                    // Case vide si pas assez de participants
                    row.push({
                        text: "",
                        border: [true, true, j === cols - 1, i === rows - 1],
                        width: badgeWidth,
                        height: badgeHeight,
                    });
                }
            }
            tableBody.push(row);
        }

        // Ajoute la page au document
        pages.push({
            table: {
                widths: new Array(cols).fill(badgeWidth),
                heights: new Array(rows).fill(badgeHeight),
                body: tableBody,
            },
            layout: {
                defaultBorder: false,
                hLineWidth: () => 1,
                vLineWidth: () => 1,
            },
            pageBreak: "after", // Séparation des pages
        });
    }

    // Supprime la pageBreak après la dernière page
    if (pages.length > 0) {
        delete pages[pages.length - 1].pageBreak;
    }

    // Document final
    const dd = {
        pageSize: "A4",
        pageMargins: [20, 20, 20, 20],
        content: pages,
    };

    return dd;
}


export function QrCode(delegue, qr, color, text) {
    var dd = [
        {
            stack: [
                {
                    canvas: [
                        {
                            type: 'rect',
                            x: 0, // Commence à 0 car on centre avec le stack
                            y: 0,
                            w: 300,
                            h: 60,
                            color: color
                        }
                    ]
                },
                {
                    text: text,
                    fontSize: 26,
                    color: 'white',
                    bold: true,
                    alignment: 'center',
                    margin: [0, -45, 0, 0] // Ajuste l'espacement pour centrer le texte verticalement
                }
            ],
            width: 60,
            alignment: 'center',
            margin: [0, 10] // Ajuste l'espacement
        },
        {text: delegue.nom.toUpperCase()+' '+capitalize(delegue.prenoms), fontSize: 18, alignment: 'center', bold: true, margin: [0, 20,0,0]},
        {image: qr, width:400, height:400, alignment: 'center'},
    ]
    return dd
}

export function listDelegues(delegues) {
    var dd = {
        pageSize: 'A4',
        pageMargins: [ 20, 30, 20, 30 ],
        content: [
            {text: 'Liste des délégués', fontSize: 24, alignment: 'center', bold: true, margin: [0, 0, 0, 20]},
            {
                table: {
                    headerRows: 1,
                    widths: [ '*','auto', 'auto', 'auto', 'auto' ],
                    body: [
                        [
                            {text: 'Id', bold: true},
                            {text: 'Civilité', bold: true},
                            {text: 'Nom', bold: true},
                            {text: 'Prénoms', bold: true},
                            {text: 'QrCode', bold: true}
                        ],
                        ...delegues.sort((a, b)=>(a.nom+' '+a.prenoms).toLowerCase()<(b.nom+' '+b.prenoms).toLowerCase()?-1:1)
                        .map(delegue => {
                            return [delegue._id, delegue.genre, delegue.nom.toUpperCase(), capitalize(delegue.prenoms), {image: delegue.qr, width:50, height:50, alignment: 'center'}]
                        })
                    ]
                }
            }
        ]
    }
    return dd
}

export function listBeneficiaires(beneficiaires) {
    var dd = {
        pageSize: 'A4',
        pageMargins: [ 20, 30, 20, 30 ],
        content: [
            {text: 'Liste des bénéficiaires de repas', fontSize: 24, alignment: 'center', bold: true, margin: [0, 0, 0, 20]},
            {
                table: {
                    headerRows: 1,
                    widths: [ '*', '*', 'auto' ],
                    body: [
                        [
                            {text: 'Nom', bold: true},
                            {text: 'Prénoms', bold: true},
                            {text: 'QrCode', bold: true}
                        ],
                        ...beneficiaires.sort((a, b)=>(a.nom+' '+a.prenoms).toLowerCase()<(b.nom+' '+b.prenoms).toLowerCase()?-1:1)
                        .map(beneficiaire => {
                            return [beneficiaire.nom.toUpperCase(), capitalize(beneficiaire.prenoms), {image: beneficiaire.qr, width:50, height:50, alignment: 'center'}]
                        })
                    ]
                }
            }
        ]
    }
    return dd
}